import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { api, errMsg } from "../../lib/api";
import { Field, Loader } from "../common";

const FIELDS = [
  ["app_name", "Nome / texto pequeno acima do título"],
  ["login_title", "Título (linha 1)"],
  ["login_highlight", "Título destacado em amarelo (linha 2)"],
  ["welcome_text", "Texto de boas-vindas", true],
  ["login_button", "Texto do botão do Google"],
  ["login_note", "Aviso ao lado do botão"],
  ["login_ads_title", "Título da área de publicidade"],
  ["login_sponsors_title", "Título da área de patrocinadores"],
];

export const LoginTexts = () => {
  const { settings, loadSettings } = useAuth();
  const [f, setF] = useState(null);
  useEffect(() => { if (settings) setF({ ...settings, login_features: (settings.login_features || []).map((x) => ({ ...x })) }); }, [settings]);
  if (!f) return <Loader />;
  const setFeat = (i, k, v) => setF({ ...f, login_features: f.login_features.map((x, j) => (j === i ? { ...x, [k]: v } : x)) });
  const save = async () => {
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, f[k] || ""]));
      await api.put("/settings", { ...body, login_features: f.login_features });
      await loadSettings();
      toast.success("Textos da página de login salvos");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="card-x space-y-4 p-5">
        <div className="h-display text-2xl">Textos principais</div>
        {FIELDS.map(([k, l, area]) => (
          <Field key={k} label={l}>
            {area ? <textarea rows={3} data-testid={`login-text-${k}`} className="inp" value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
              : <input data-testid={`login-text-${k}`} className="inp" value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} />}
          </Field>
        ))}
      </div>
      <div className="card-x space-y-4 p-5">
        <div className="h-display text-2xl">Cartões de destaque</div>
        {f.login_features.map((x, i) => (
          <div key={i} className="grid grid-cols-2 gap-2">
            <input data-testid={`login-feature-title-${i}`} className="inp" value={x.title} onChange={(e) => setFeat(i, "title", e.target.value)} placeholder="Título" />
            <input data-testid={`login-feature-desc-${i}`} className="inp" value={x.desc} onChange={(e) => setFeat(i, "desc", e.target.value)} placeholder="Descrição" />
          </div>
        ))}
      </div>
      <button data-testid="login-texts-save-btn" onClick={save} className="btn-lime rounded-full py-3 lg:col-span-2">Salvar textos</button>
    </div>
  );
};
